import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const RankIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M1.25193 4.97805L7.75193 1.14417C7.90565 1.05351 8.09435 1.05351 8.24807 1.14417L14.7481 4.97805C14.9039 5.06994 15 5.24095 15 5.42615V6.30172C15 6.69799 14.5853 6.94642 14.2519 6.74982L8.24807 3.20857C8.09435 3.1179 7.90565 3.1179 7.75193 3.20857L1.74807 6.74982C1.41474 6.94642 1 6.69799 1 6.30172V5.42615C1 5.24095 1.09614 5.06994 1.25193 4.97805Z"
		></path>
		<path
			fill="currentColor"
			d="M1.25193 9.10685L7.75193 5.27297C7.90565 5.1823 8.09435 5.1823 8.24807 5.27297L14.7481 9.10685C14.9039 9.19874 15 9.36975 15 9.55495V10.4305C15 10.8268 14.5853 11.0752 14.2519 10.8786L8.24807 7.33737C8.09435 7.2467 7.90565 7.2467 7.75193 7.33737L1.74807 10.8786C1.41474 11.0752 1 10.8268 1 10.4305V9.55495C1 9.36975 1.09614 9.19874 1.25193 9.10685Z"
		></path>
		<path
			fill="currentColor"
			d="M7.74315 9.40694L1.25193 13.2356C1.09614 13.3275 1 13.4985 1 13.6837V14.5593C1 14.9556 1.41474 15.204 1.74807 15.0074L7.75193 11.4662C7.90565 11.3755 8.09435 11.3755 8.24807 11.4662L14.2519 15.0074C14.5853 15.204 15 14.9556 15 14.5593V13.5C15 13.3204 14.9095 13.1536 14.7611 13.0598L8.2523 9.41489C8.0967 9.31656 7.90156 9.31351 7.74315 9.40694Z"
		></path>
	</svg>
))
